import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "24",
  viewBox: "0 0 23 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.79167 3C3.52601 3 2.5 4.02601 2.5 5.29167V15.7083C2.5 16.974 3.52601 18 4.79167 18H15.2083C16.474 18 17.5 16.974 17.5 15.7083V5.29167C17.5 4.02601 16.474 3 15.2083 3H4.79167ZM6.66667 9.66667C6.20643 9.66667 5.83333 10.0398 5.83333 10.5C5.83333 10.9602 6.20643 11.3333 6.66667 11.3333C7.1269 11.3333 7.5 10.9602 7.5 10.5C7.5 10.0398 7.1269 9.66667 6.66667 9.66667ZM6.66667 13C6.20643 13 5.83333 13.3731 5.83333 13.8333C5.83333 14.2936 6.20643 14.6667 6.66667 14.6667C7.1269 14.6667 7.5 14.2936 7.5 13.8333C7.5 13.3731 7.1269 13 6.66667 13ZM9.16667 13.8333C9.16667 13.3731 9.53976 13 10 13C10.4602 13 10.8333 13.3731 10.8333 13.8333C10.8333 14.2936 10.4602 14.6667 10 14.6667C9.53976 14.6667 9.16667 14.2936 9.16667 13.8333ZM10 9.66667C9.53976 9.66667 9.16667 10.0398 9.16667 10.5C9.16667 10.9602 9.53976 11.3333 10 11.3333C10.4602 11.3333 10.8333 10.9602 10.8333 10.5C10.8333 10.0398 10.4602 9.66667 10 9.66667ZM12.5 10.5C12.5 10.0398 12.8731 9.66667 13.3333 9.66667C13.7936 9.66667 14.1667 10.0398 14.1667 10.5C14.1667 10.9602 13.7936 11.3333 13.3333 11.3333C12.8731 11.3333 12.5 10.9602 12.5 10.5ZM4.79167 4.25C4.21637 4.25 3.75 4.71637 3.75 5.29167V6.33333H16.25V5.29167C16.25 4.71637 15.7836 4.25 15.2083 4.25H4.79167Z",
      fill: "#489ffa"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 22.75C19.1756 22.75 21.75 20.1756 21.75 17C21.75 13.8244 19.1756 11.25 16 11.25C12.8244 11.25 10.25 13.8244 10.25 17C10.25 20.1756 12.8244 22.75 16 22.75Z",
      fill: "#489ffa",
      stroke: "#F2F5FF",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }